import { render, staticRenderFns } from "./alarmMessage.vue?vue&type=template&id=2e87432a&"
import script from "./alarmMessage.vue?vue&type=script&lang=js&"
export * from "./alarmMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports